import { render } from "./ActivityModal.vue?vue&type=template&id=0a8787cb&scoped=true&ts=true"
import script from "./ActivityModal.vue?vue&type=script&lang=ts"
export * from "./ActivityModal.vue?vue&type=script&lang=ts"

import "./ActivityModal.vue?vue&type=style&index=0&id=0a8787cb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8787cb"]])

export default __exports__